import {request} from '@/utils/request'

//查询用户详情
export function userQuery(data, that, loading = false) {
    return request({
        url: '/srm/user/query',
        data: data,
        params: {},
        that,
        method: 'post',
        loading: loading,
    })
}
//添加用户
export function addUser(data, that, loading = false) {
    return request({
        url: '/srm/user/addUser',
        data: data,
        params: {},
        that,
        method: 'post',
        loading: loading,
    })
}
//更新用户
export function updateUser(data, that, loading = false) {
    return request({
        url: '/srm/user/updateUser',
        data: data,
        params: {},
        that,
        method: 'post',
        loading: loading,
    })
}
//删除用户
export function deleteUser(data, that, loading = false) {
    return request({
        url: '/srm/user/deleteUser',
        data: {},
        params: data,
        that,
        method: 'post',
        loading: loading,
    })
}